import { Navigate } from "react-router";

/** Legacy URL: reindirizza al Control Hub e apre il pannello Ask Eve */
export const ReceiverAskEvePage = () => (
    <Navigate to="/receiver/control-hub" replace state={{ openAskEve: true }} />
);
